<div [id]="'chart-container'+id" [ngStyle]="{ height: popUp ? '28em' : height }"></div>
